import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { FileText, Video, Calendar } from 'lucide-react';
import { contentLibrary } from '../mockData';

const Content = () => {
  return (
    <div className="min-h-screen py-16 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center">
            <FileText className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-5xl font-bold mb-4 text-gray-900">Content Library</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore articles, videos, and insights from Udbhav 1.0 and beyond
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex justify-center mb-12 space-x-4">
          <Button className="bg-blue-600 hover:bg-blue-700">All Content</Button>
          <Button variant="outline" className="border-blue-300 text-blue-700 hover:bg-blue-50">Articles</Button>
          <Button variant="outline" className="border-blue-300 text-blue-700 hover:bg-blue-50">Videos</Button>
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {contentLibrary.map((item) => (
            <Card key={item.id} className="border-2 border-gray-200 hover:border-blue-300 transition-all duration-300 hover:shadow-xl overflow-hidden group">
              {item.type === 'video' && (
                <div className="aspect-video bg-gray-900 relative overflow-hidden">
                  <img 
                    src={item.thumbnail} 
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                    <Video className="w-16 h-16 text-white" />
                  </div>
                </div>
              )}
              <CardHeader>
                <div className="flex items-center justify-between mb-3">
                  <Badge className="bg-blue-100 text-blue-800 hover:bg-blue-100">
                    {item.type === 'article' ? <FileText className="w-3 h-3 mr-1" /> : <Video className="w-3 h-3 mr-1" />}
                    {item.type}
                  </Badge>
                  {item.type === 'article' && (
                    <span className="text-sm text-gray-600">{item.readTime}</span>
                  )}
                  {item.type === 'video' && (
                    <span className="text-sm text-gray-600">{item.duration}</span>
                  )}
                </div>
                <CardTitle className="text-xl">{item.title}</CardTitle>
                {item.type === 'article' && (
                  <>
                    <CardDescription className="text-base">{item.excerpt}</CardDescription>
                    <div className="flex items-center text-sm text-gray-600 mt-3">
                      <Calendar className="w-4 h-4 mr-1" />
                      {new Date(item.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </div>
                    <div className="text-sm text-gray-600">By {item.author}</div>
                  </>
                )}
              </CardHeader>
              <CardContent>
                <Button className="w-full bg-blue-600 hover:bg-blue-700">
                  {item.type === 'article' ? 'Read Article' : 'Watch Video'}
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Load More */}
        <div className="text-center mt-12">
          <Button variant="outline" className="border-blue-300 text-blue-700 hover:bg-blue-50 px-8">
            Load More Content
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Content;